module.exports = __webpack_public_path__ + "img/nature.aef357a3.jpg";